import React from 'react';
import PropTypes from 'prop-types';

import '../../style.scss';

const SidebarSwitch = ({ toggleSidebar }) => (
  <button styleName="sidebar__switch" onClick={toggleSidebar}>
    <i className="icon-expand" data-test="icon-expand" />
  </button>
);

SidebarSwitch.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
};

export default SidebarSwitch;
